// UploadClinicalNotesModal.jsx
import React from "react";
import UploadDocumentModal from "../patient/UploadDocumentModal";

/**
 * Reuses the existing UploadDocumentModal UI but presets it for Clinical Notes.
 * Assumes UploadDocumentModal accepts:
 *  - open, onClose, patient, onUploadSuccess
 * If UploadDocumentModal supports preset props like documentType/title, pass them.
 */
const UploadClinicalNotesModal = ({ open, onClose, patient, onUploadSuccess }) => {
  return (
    <UploadDocumentModal
      open={open}
      onClose={onClose}
      patient={patient}
      onUploadSuccess={onUploadSuccess}
      // Optional: ONLY if UploadDocumentModal supports these props
      // defaultDocumentType="clinical_notes"
      // defaultTitle="Clinical Notes"
      // hideDocumentTypeSelector={true}
    />
  );
};

export default UploadClinicalNotesModal;
